import React, {Component} from 'react';
import ModalWrapper from "../ModalWrapper";
import "./styles/AAFModalTelmexMessageMethodPayment.scss";
import Button from "../../Button";
import Translator from "../../../requests/apa/Translator";
import Utils from "../../../utils/Utils";
import store from "../../../store";
import {
  HIDE_MODAL,
  showModal
} from "../../../actions/modal";

class AAFModalTelmexMessageMethodPayment extends Component {
  constructor(props) {
    super(props);
    this.keysMetadata = {
      title: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Titulo",
      subtitle: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Parrafo1",
      titleOptions: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Parrafo2",
      option1: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Lista_Parte1",
      option2: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Lista_Parte2",
      option3: "MDP_MetodosDePago_ModalTransaccionWeb_Texto_Lista_Parte3",
      accept: "MDP_Boton_Texto_Aceptar"
    };
    this.state = {
      text: {
        title: Translator.get(this.keysMetadata.title),
        subtitle: Translator.get(this.keysMetadata.subtitle ),
        titleOptions: Translator.get(this.keysMetadata.titleOptions ),
        option1: Translator.get(this.keysMetadata.option1),
        option2: Translator.get(this.keysMetadata.option2 ),
        option3: Translator.get(this.keysMetadata.option3),
        accept: Translator.get(this.keysMetadata.accept)
      },
      numChars: {
        title: 65,
        subtitle: 82,
        titleOptions: 38,
        option1: 35,
        option2: 35,
        option3: 35,
        accept: 10
      }
    };
  }

  cutString() {
    const texts = this.state.text;
    const numChars = this.state.numChars;
    const keysTexts = Object.keys(texts);

    keysTexts.forEach((key) => {
      if (texts[key] !== this.keysMetadata[key]) {
        texts[key] = Utils.cutPlayerString(texts[key], numChars[key], null, "...");
      }
    });

    return texts
  }

  handleAccept = () => {
    store.dispatch(showModal({
      modalType: HIDE_MODAL,
      modalProps: {}
    }))
  }

  handleBack = () => {
    store.dispatch(showModal({
      modalType: HIDE_MODAL,
      modalProps: {}
    }));
  }

  render() {
    const {
      title,
      subtitle,
      titleOptions,
      option1,
      option2,
      option3,
      accept
    } = this.cutString();
    const options = [option1, option2, option3];

    return (
      <ModalWrapper className={"modal-telmex-message-method-payment"} callbackWhenBack={this.handleBack}>
        <div className="modal-content-message">
          <div className="modal-content-message_paragraphs">
            <div className="paragraphs_titile">
              <p className={"title-text"}>{title}</p>
            </div>
            <div className="paragraphs_texts">
              <p className={"texts_title"}>{subtitle}</p>
              <p className={"texts_title-options"}>{titleOptions}</p>
              <ul className={"text_list"}>
                {options && options.map((option, key) => (
                    option && option !== "" &&
                    <li key={key} className={"list_element"}>{option}</li>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="modal-footer-message">
            <Button
              activate
              id="acceptButton"
              type="button"
              variant="primary"
              className={"primaryButton focusable"}
              text={accept}
              onClick={this.handleAccept}
            />
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default AAFModalTelmexMessageMethodPayment;



// WEBPACK FOOTER //
// ./src/components/Modal/Telmex/AAFModalTelmexMessageMethodPayment.jsx